<form class="modal-body wrapper-modal position-relative">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>

  <!-- Paso 1: filtros (solo modo crear) -->
  <section *ngIf="step === 1" class="py-0 px-2 px-md-3 px-lg-4">
    <p class="title mx-3">{{ title }}</p>
    <p class="mb-3">{{ subtitle }}</p>
    <div class="d-flex justify-content-center mb-3" *ngIf="transportCompanyId">
      <app-transport-company-context [initialNit]="transportCompanyId" [readonly]="true"></app-transport-company-context>
    </div>

    <div class="d-flex flex-wrap">
      <app-select-company class="col-12" [options]="{ title: 'Cliente', appearance: 'outline' }"
        [inputFormControl]="companyControl" [validate]="companyValidate">
      </app-select-company>
      <mat-form-field appearance="outline" class="col-12 col-md-6">
        <mat-label>Desde<span class="asterisk">*</span></mat-label>
        <input matInput [matDatepicker]="pickerFrom" [formControl]="dateFromControl" [max]="dateToControl.value"
          placeholder="Desde" readonly (click)="pickerFrom.open()">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error *ngIf="dateFromControl.errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-12 col-md-6">
        <mat-label>Hasta<span class="asterisk">*</span></mat-label>
        <input matInput [matDatepicker]="pickerTo" [formControl]="dateToControl" [min]="dateFromControl.value"
          placeholder="Hasta" readonly (click)="pickerTo.open()">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
        <mat-error *ngIf="dateToControl.errors?.required">
          {{ utils.giveMessageError('MANDATORY_FIELD') }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="button-container mt-2">
      <button type="button" mat-raised-button color="primary" class="bg-color-primary" (click)="searchInitialCargos()">
        Buscar cargas
      </button>
    </div>
  </section>

  <!-- Paso 2: selección de cargas (crear y editar) -->
  <section *ngIf="step === 2" class="py-0 px-2 px-md-3 px-lg-4">
    <p class="title mx-3">{{ title }}</p>
    <p class="mb-3">{{ subtitle }}</p>
    <div class="d-flex justify-content-center mb-3" *ngIf="transportCompanyId">
      <app-transport-company-context [initialNit]="transportCompanyId" [readonly]="true"></app-transport-company-context>
    </div>

    <div class="d-flex flex-wrap mb-3 align-items-baseline">
      <mat-form-field appearance="outline" class="col-sm-8">
        <mat-label>Consecutivo</mat-label>
        <input matInput type="text" placeholder="Digita un consecutivo" [formControl]="consecutiveControl"
          (keydown.enter)="$event.preventDefault(); searchConsecutives()">
        <mat-error *ngIf="consecutiveControl.errors?.pattern">
          {{ utils.giveMessageError('INCORRECT_FORMAT', 'consecutivo') }}
        </mat-error>
      </mat-form-field>
      <div class="col-sm-4">
        <button type="button" mat-raised-button class="primary-secondary w-100" color="primary"
          (click)="searchConsecutives()">Agregar</button>
      </div>
    </div>

    <div *ngIf="cargos.length" class="cargos-list-header mb-2 d-flex justify-content-between align-items-center">
      <span>{{ selectedCount }} de {{ cargos.length }} seleccionada(s)</span>
      <i matTooltip="Recargar listado" class="fas fa-sync-alt cursor-pointer refresh-cargos-icon"
        (click)="refreshCargos()"></i>
    </div>

    <div *ngIf="cargos.length; else noCargos" class="table-responsive cargos-table-wrapper">
      <table class="cargos-table">
        <thead>
          <tr>
            <th class="col-check"></th>
            <th>ID</th>
            <th>Fecha cargue</th>
            <th>Origen</th>
            <th>Destino</th>
            <th *ngIf="someCargoHasManifest">Manifiesto</th>
            <th *ngIf="someCargoHasConsignments">Remesa/s</th>
            <th>Tarifa</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of cargos; trackBy: trackByCargo" [class.is-selected]="item?.checked"
            [class.is-disabled]="item?.errorMessage">
            <td class="col-check" [matTooltip]="item?.errorMessage" matTooltipClass="tooltip__error">
              <mat-checkbox [(ngModel)]="item.checked" [ngModelOptions]="{ standalone: true }" color="primary"
                [disabled]="item?.errorMessage"></mat-checkbox>
            </td>
            <td class="text-bold underline cursor-pointer" (click)="openCargoDetail(item?.cargo)">{{
              item?.cargo?.consecutive || '-' }}</td>
            <td>
              {{ item?.cargo?.dateLoad ? (item?.cargo?.dateLoad | dateFormat: 'only-date') : '-' }}
            </td>
            <td>{{ getCargoOrigin(item?.cargo) || '-' }}</td>
            <td>{{ getCargoDestination(item?.cargo) || '-' }}</td>
            <td *ngIf="someCargoHasManifest">{{ item?.cargo?.manifest || '-' }}</td>
            <td *ngIf="someCargoHasConsignments">{{ getConsignmentsLabel(item?.cargo) || '-' }}</td>
            <td>
              {{ getCargoRate(item?.cargo) ? (getCargoRate(item?.cargo) | currency:'COP':'code') : '-' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #noCargos>
      <p class="text-center text-muted my-4">No hay cargas en el listado.</p>
    </ng-template>

    <div class="button-container mt-3">
      <button *ngIf="mode === 'create'" type="button" mat-raised-button class="primary-secondary button-width-auto"
        (click)="backStep()">
        Atrás
      </button>
      <button type="button" mat-raised-button color="primary" class="bg-color-primary" (click)="onSubmit()">
        {{ mode === 'update' ? 'Guardar cambios' : 'Generar prefactura' }}
      </button>
    </div>
  </section>
</form>